<template>
  <el-tree
    :check-strictly="true"
    :data="treeData"
    node-key="id"
    :highlight-current="true"
    :props="props"
    @node-click="handleClick"
    ref="dataTree"
  >
  </el-tree>

  <!-- :check-strictly="true" -->
  <!-- :load="loadNode" -->
</template>
<script>
export default {
  name: "subconNatureTree",
  props: {
    treeData: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      natureObj: {},
      props: {
        label: "name",
        children: "children",
        isLeaf: "natureCode",
      },
    };
  },
  mounted() {},
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      this.natureObj = data;

      // if (checked) {
      //   this.$refs.dataTree.setCheckedKeys([data.id]);
      //   this.company = data;
      // }
    },
    handleClick(data, node, _slef) {
      if (node.level >= 2) {
        this.natureObj = data;
      } else {
        this.natureObj = null;
      }
    },
  },
};
</script>
